/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
const FlutterWave = ({ Amount, attributes }) => {

    const { setTransactionId, setPaymentLod } = useContext(MyContext);

    const navigate = useNavigate();
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    const loadFlutterwaveScript = async () => {
        const script = document.createElement('script');
        script.src = "https://checkout.flutterwave.com/v3.js";
        script.async = true;

        script.onload = () => {
            setIsScriptLoaded(true);
            // console.log('Flutterwave script loaded successfully!');
        };

        script.onerror = () => {
            console.error("Failed to load Flutterwave script.");
        };
        document.body.appendChild(script);
    };

    useEffect(() => {
        loadFlutterwaveScript();
    }, []);

    const handlePayment = () => {
        // console.log('Attempting to handle payment');

        sessionStorage.setItem("Amount", Amount);

        if (!isScriptLoaded) {
            console.error('Flutterwave script is not loaded.');
            return;
        }

        setPaymentLod(false);

        const localData = secureLocalStorage.getItem("LoginData");

        if (!localData) return;

        const parsedData = JSON.parse(localData);

        const paymentOptions = {
            tx_ref: Date.now(),
            amount: Amount,
            currency: 'USD',
            email: parsedData.email,
            phone_number: parsedData.mobile,
            public_key: attributes.split(",")[1],
            callback: (data) => {
                if (data.status === 'successful') {
                    // setPaymentRes("PaymentDone");
                    sessionStorage.setItem("Paymentstatus", "PaymentDone");
                    setTransactionId(data.transaction_id);
                    navigate(0);
                } else {
                    sessionStorage.setItem("Paymentstatus", "PaymentFaild");
                }
            },
            onClose: () => {
                sessionStorage.setItem("Payment", "Payment Failed.!!");
            },
            customer: {
                email: parsedData.email,
                phone_number: parsedData.mobile,
            },
        };

        if (window.FlutterwaveCheckout) {
            window.FlutterwaveCheckout(paymentOptions);
        } else {
            console.error('FlutterwaveCheckout function is not available.');
        }
    };

    useEffect(() => {
        if (isScriptLoaded && Amount) {
            handlePayment();
        }
    }, [isScriptLoaded, Amount]);

    return null;
};

export default FlutterWave;
/* jshint ignore:end */